/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CodebookExitResponse } from '../models/CodebookExitResponse';
import type { CreateCodebookExitRequest } from '../models/CreateCodebookExitRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CodebookExitApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create Codebook
   * @param requestBody
   * @returns any Create codebook
   * @throws ApiError
   */
  public createCodebookExit(
    requestBody?: CreateCodebookExitRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/codebook-exit',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns any Get codebook
   * @throws ApiError
   */
  public getCodebookExits(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<{
    items: Array<CodebookExitResponse>;
    totalItems: number;
    totalPages: number;
    page: number;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/codebook-exit',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook
   * @param id
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns any Get codebook
   * @throws ApiError
   */
  public getCodebookExitsByWarehouseId(
    id: string,
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<{
    items: Array<CodebookExitResponse>;
    totalItems: number;
    totalPages: number;
    page: number;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/codebook-exits/{id}',
      path: {
        'id': id,
      },
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook by id
   * @param id
   * @returns CodebookExitResponse Get codebook response
   * @throws ApiError
   */
  public getCodebookExitById(
    id: string,
  ): CancelablePromise<CodebookExitResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/codebook-exit/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
